export enum KnockautXModuleGuids {
  Co2Sensor = '{A407FBD2-F78C-2FC3-E287-C260741E492C}',
  Dimmaktor = '{4AEDFFBA-CB6C-B29B-27BD-043785222352}',
  DoorWindowSensor = '{3240D96F-90DF-D7CD-AA05-28B3D8AAF746}',
  HumanPresenceSensor = '{B2559EE5-15B3-10D3-B1C9-ECC1DA9BB774}',
  IndoorSiren = '{E1626F96-81DC-0F6B-F69C-9342AAD56A0C}',
  KnobDimmerSwitch = '{7D89DA39-1A59-D421-8BE1-CEAF4F22DE9B}',
  KnockautXSplitter = '{7A84E4E4-920B-C4D9-5B0D-9B2A6409FC9B}',
  LEDRGBE14 = '{CDC03733-582C-5ABA-1BC6-8D208D98B98D}',
  LEDRGBE27 = '{C078B597-F469-1033-E796-D862E65F8E5B}',
  LEDRGBGU10 = '{7DB37997-2B5A-7A16-24EE-F890454CD045}',
  MasterGatewayTWO = '{ACF80F34-9A95-A63B-50F8-01F3FFEE60A2}',
  MotionSensor = '{C131870C-696F-20BB-5A60-9C40FFCD3693}',
  Repeater = '{5C2C4710-B70C-14C9-0BE2-8D139B247068}',
  SchaltSteckdose = '{6B64A27C-35BC-D48C-76C9-73AC7DA3D289}',
  Schaltaktor = '{7CFA1D77-782E-9746-1BC2-7151EFFBAAAA}',
  SmartElectricMeter = '{8F058C6F-FFF4-6D6E-E8C0-4D6879918C67}',
  SmokeDetector = '{95D0B6D4-70F5-BDB5-6D61-60A55960E38D}',
  SunblindVibrationSensor = '{885E6941-E111-CF95-EA19-F0F68FAAF563}',
  TemperatureHumiditySensor = '{98648CA8-1AFC-55FF-CCE0-011351301922}',
  TemperatureHumiditySensorLCD = '{C6AA8CA2-5778-EFC3-7EBE-70F603C31764}',
  Thermostat = '{41FCFD9A-FB59-9865-B349-DFD0A5E9F963}',
  VibrationSensor = '{54F7E29C-833B-530E-891C-DCE5320DEEF5}',
  WallThermostat = '{5301383A-B412-464A-1F67-A13E21F027AB}',
  WaterSensor = '{C5763338-97B9-8813-BC40-AB18693E97AF}',
  WirelessSwitch1Channel = '{C913AC7B-44DA-255B-D679-1BBB31D133A0}',
  WirelessSwitch4Channel = '{C087D434-EF64-049C-5C76-AD26C1EB9965}',
  WirelessSwitchMini1Channel = '{C9DB389E-3858-ED80-EF1D-BB1F1F73047C}',
}

export const KNOCKAUT_X_MODULE_IDS = [
  KnockautXModuleGuids.Co2Sensor.valueOf(),
  KnockautXModuleGuids.Dimmaktor.valueOf(),
  KnockautXModuleGuids.DoorWindowSensor.valueOf(),
  KnockautXModuleGuids.HumanPresenceSensor.valueOf(),
  KnockautXModuleGuids.IndoorSiren.valueOf(),
  KnockautXModuleGuids.KnobDimmerSwitch.valueOf(),
  KnockautXModuleGuids.KnockautXSplitter.valueOf(),
  KnockautXModuleGuids.LEDRGBE14.valueOf(),
  KnockautXModuleGuids.LEDRGBE27.valueOf(),
  KnockautXModuleGuids.LEDRGBGU10.valueOf(),
  KnockautXModuleGuids.MasterGatewayTWO.valueOf(),
  KnockautXModuleGuids.MotionSensor.valueOf(),
  KnockautXModuleGuids.Repeater.valueOf(),
  KnockautXModuleGuids.SchaltSteckdose.valueOf(),
  KnockautXModuleGuids.Schaltaktor.valueOf(),
  KnockautXModuleGuids.SmartElectricMeter.valueOf(),
  KnockautXModuleGuids.SmokeDetector.valueOf(),
  KnockautXModuleGuids.SunblindVibrationSensor.valueOf(),
  KnockautXModuleGuids.TemperatureHumiditySensor.valueOf(),
  KnockautXModuleGuids.TemperatureHumiditySensorLCD.valueOf(),
  KnockautXModuleGuids.Thermostat.valueOf(),
  KnockautXModuleGuids.VibrationSensor.valueOf(),
  KnockautXModuleGuids.WallThermostat.valueOf(),
  KnockautXModuleGuids.WaterSensor.valueOf(),
  KnockautXModuleGuids.WirelessSwitch1Channel.valueOf(),
  KnockautXModuleGuids.WirelessSwitch4Channel.valueOf(),
  KnockautXModuleGuids.WirelessSwitchMini1Channel.valueOf(),
]
